import i18next from 'i18next';

const handleUntranslatedSignal = (label: string): string => {
  if (label == null || typeof label !== 'string') {
    return '';
  }
  return label
    .replace('mlrisk', 'ML_risk')
    .replace('p2p', 'P2P')
    .split('_')
    .join(' ');
};

export default function getSignalTranslation(
  label: string | null | undefined,
  prefix: string = 'signal_', // `signal_`, `src_`
): string {
  if (label == null || typeof label !== 'string' || !label) {
    return '';
  }
  return i18next.t(
    `translation.${prefix}${label}`,
    handleUntranslatedSignal(label),
  );
}
